import {NgModule} from '@angular/core';
import {NoPreloading, RouterModule, Routes} from '@angular/router';
import {CanAccess} from './guards/secured.guard';

const routes: Routes = [
	{
		path: 'login',
		loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
	},
	{
		path: 'redirect',
		loadChildren: () => import('./pages/redirect/redirect.module').then(m => m.RedirectPageModule)
	},
	{
		path: 'home',
		loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
		canActivate: [CanAccess]
	},
	{
		path: 'conventions',
		loadChildren: () => import('./pages/conventions/conventions.module').then(m => m.ConventionsPageModule),
		canActivate: [CanAccess]
	},
	{
		path: 'conventions/:id',
		loadChildren: () => import('./pages/convention/convention.module').then(m => m.ConventionPageModule),
		canActivate: [CanAccess]
	},
	{
		path: 'suivi-conventions',
		loadChildren: () => import('./pages/suivi-conventions/suivi-conventions.module').then(m => m.SuiviConventionsPageModule),
		canActivate: [CanAccess]
	},
	{
		path: 'indicateurs',
		loadChildren: () => import('./pages/indicateurs/indicateurs.module').then(m => m.IndicateursPageModule),
		canActivate: [CanAccess]
	},
	{
		path: 'planning',
		loadChildren: () => import('./pages/planning/planning.module').then(m => m.PlanningPageModule),
		canActivate: [CanAccess]
	},
	{
		path: 'marches',
		loadChildren: () => import('./pages/marches/marches.module').then(m => m.MarchesPageModule),
		canActivate: [CanAccess]
	},
	{
		path: 'marches/:id',
		loadChildren: () => import('./pages/marche/marche.module').then(m => m.MarchePageModule),
		canActivate: [CanAccess]
	},
	{
		path: 'feuilles-heures',
		loadChildren: () => import('./pages/feuilles-heures/feuilles-heures.module').then(m => m.FeuillesHeuresPageModule),
		canActivate: [CanAccess]
	},
	{
		path: 'feuilles-heures/:id',
		loadChildren: () => import('./pages/feuilles-heures-form/feuilles-heures-form.module').then(m => m.FeuillesHeuresFormPageModule),
		canActivate: [CanAccess]
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {preloadingStrategy: NoPreloading, useHash: true})
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
